import {
  isIso12100Reference as isIso12100ReferenceShared,
  type MachineryStandardClass,
} from '@artem-lex/common-server/standards/iso12100'
import { isTypeAStandard as isTypeAStandardShared } from '@artem-lex/common-server/standards/standardKinds'

export { type MachineryStandardClass }

export function isIso12100Reference(reference: string): boolean {
  return isIso12100ReferenceShared(reference)
}

export function isTypeCStandard(type: string): boolean {
  return type.trim().toUpperCase() === ('C' satisfies MachineryStandardClass)
}

export function isTypeAStandard(type: string): boolean {
  return isTypeAStandardShared(type)
}

